// Create a new file: src/utils/environment.ts
export const isProdEnvironment = (): boolean => {
  return window.location.hostname.includes("eon.health");
};
